var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/fill/arrow-left-alt",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.79999828,11.52 C4.79921375,10.8847658 5.07205543,10.2799668 5.54879997,9.86015999 L16.25472,0.441599952 C16.9925673,-0.177532157 18.0897343,-0.0943958886 18.725865,0.628847455 C19.3619958,1.3520908 19.3044079,2.45089498 18.59616,3.10367996 L9.23423999,11.33952 C9.18225143,11.3850904 9.15243913,11.4508663 9.15243913,11.52 C9.15243913,11.5891337 9.18225143,11.6549096 9.23423999,11.70048 L18.59616,19.93632 C19.0889635,20.3498344 19.3191361,20.9978295 19.1976106,21.629558 C19.0760851,22.2612864 18.6219274,22.7776371 18.010878,22.9788034 C17.3998285,23.1799697 16.7277542,23.0343909 16.25472,22.5984 L5.55263997,13.18272 C5.07474138,12.7621944 4.80060445,12.1565756 4.79999828,11.52 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.5bc77136.svg";
export { ForwardRef as ReactComponent };